module.exports = __webpack_public_path__ + "media/images/games/rocket-league/hiw-4-58764560c02a2db516a99f32cd0d2675.jpg";